export default __webpack_public_path__ + "static/media/profile.87d8e407.jpg";